import React from "react";

import { useTranslation } from "react-i18next";
import classnames from "classnames/dedupe";
import { Input } from "reactstrap";
import Select from "react-select";

import { customStyles } from "components/custom-modal-elements/custom-modal-select";
import { DateTimePicker } from "components/prime-date-time-picker/date-time-picker";

import styles from "./AdvancedFilters.module.scss";

const getInputType = (advancedFilter, filter) => {
    if (advancedFilter?.type) return advancedFilter?.type;
    if (advancedFilter?.filterOptionConfig) return "dropdown";
    else if (advancedFilter?.type == "checkbox") return "checkbox";
    else if (filter.filterField?.endsWith("Dt")) return "date";
    else return "text";
};

export const FilterInput = (props) => {
    const { advancedFilter, filter, onChange, filterValueOptions, index, placeholder } = props;

    const { t } = useTranslation();

    const inputType = getInputType(advancedFilter, filter);

    const getDropdownOptions = () => {
        const modelOptions =
            filterValueOptions?.[advancedFilter?.filterOptionConfig?.appModelPath]?.[advancedFilter.filterOptionConfig.field];

        if (modelOptions?.length) return modelOptions;
        else return filterValueOptions?.[advancedFilter?.field];
    };

    const dropdownOptions = getDropdownOptions();

    return (
        <>
            {
                {
                    dropdown: (
                        <Select
                            className="custom-gt-select"
                            styles={customStyles}
                            options={dropdownOptions}
                            getOptionLabel={(o) => t(o.label)}
                            getOptionValue={(o) => o.value}
                            onChange={(o) => onChange(o.value, index, "value")}
                            placeholder={placeholder}
                            value={dropdownOptions?.find((o) => o.value == filter.value)}
                            noOptionsMessage={({ inputValue }) => !inputValue && t("No options")}
                        />
                    ),
                    checkbox: (
                        <Select
                            className="custom-gt-select"
                            styles={customStyles}
                            options={filterValueOptions?.additionalOptions?.checkboxOptions}
                            getOptionLabel={(o) => t(o.label)}
                            getOptionValue={(o) => o.value}
                            onChange={(o) => onChange(o.value, index, "value")}
                            placeholder={placeholder}
                            value={filterValueOptions.additionalOptions.checkboxOptions?.find((o) => o.value == filter.value) || null}
                            noOptionsMessage={({ inputValue }) => !inputValue && t("No options")}
                        />
                    ),
                    date: (
                        <DateTimePicker
                            value={filter.value}
                            onChange={(e) => onChange(e.target.value, index, "value")}
                            className=" w-100"
                            row={false}
                            containerClassName={classnames(styles.datePicker, "mb-0")}
                            noLabel
                            appendTo={"self"}
                            selectionMode={filter?.filterType === "__range" ? "range" : "single"}
                            validateRange={false}
                        />
                    ),
                    text: (
                        <Input
                            type="text"
                            onChange={(e) => onChange(e.target.value, index, "value")}
                            value={filter.value}
                            placeholder={placeholder}
                        />
                    ),
                    number: (
                        <Input
                            type="number"
                            onChange={(e) => onChange(e.target.value, index, "value")}
                            value={filter.value}
                            placeholder={placeholder}
                        />
                    ),
                }[inputType]
            }
        </>
    );
};
